var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KCheckbox',{attrs:{"label":`selectedObject = ${JSON.stringify(_vm.selectedObject)}`,"value":{ id: 1, name: 'Name 1' }},model:{value:(_vm.selectedObject),callback:function ($$v) {_vm.selectedObject=$$v},expression:"selectedObject"}})
}
var staticRenderFns = []

export { render, staticRenderFns }